import { ThemeProvider } from '@aws-amplify/ui-react';
import App from "./App";
import GuestApp from "./GuestApp";
import { useAuthenticator } from '@aws-amplify/ui-react';
import AppHeader from "./AppHeader/AppHeader";
import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../store/actions/actions';
import EventsApi from '../api/EventsApi';
import { fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
import { getUrl } from 'aws-amplify/storage';

const AppWithAuth = (props) => {
    const { onGetImagesStats, onSetUserData, onClearUserData } = props;
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const { authStatus  } = useAuthenticator(context => [context.authStatus]);

    // Load global data when user is authenticated
    useEffect(() => {
        if (authStatus === 'authenticated') {
            // Load images stats
            EventsApi.getImagesStats().then(response => {
                console.log('Loading global images stats', response);
                onGetImagesStats(response.imagesstats);
            }).catch(error => {
                console.error('Error loading images stats:', error);
            });

            // Load user data
            const loadUserData = async () => {
                try {
                    const [attributes, currentUser] = await Promise.all([
                        fetchUserAttributes(),
                        getCurrentUser()
                    ]);

                    let avatarUrl = null;
                    if (attributes.picture) {
                        try {
                            const url = await getUrl({ 
                                key: attributes.picture, 
                                options: { accessLevel: 'public' } 
                            });
                            avatarUrl = url.url;
                        } catch (error) {
                            console.log('Avatar not found, using default');
                        }
                    }

                    const userData = {
                        username: currentUser.username || attributes.email?.split('@')[0] || 'User',
                        email: attributes.email,
                        avatarUrl: avatarUrl?.toString()
                    };

                    console.log('Loading global user data', userData);
                    onSetUserData(userData);
                } catch (error) {
                    console.error('Error loading user data:', error);
                }
            };

            loadUserData();
        } else if (authStatus === 'unauthenticated') {
            // Clear user data when logged out
            onClearUserData();
        }
    }, [authStatus, onGetImagesStats, onSetUserData, onClearUserData]);

    return (
        <ThemeProvider>
            <AppHeader authStatus={authStatus} isHome={isHomePage}/>
            {authStatus === 'configuring' && 'Loading...'}
            {authStatus === 'authenticated' && <App {...props}/>}
            {authStatus === 'unauthenticated' && <GuestApp />}
        </ThemeProvider>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetImagesStats: (currentImagesStats) => dispatch(actionCreators.getImagesStats(currentImagesStats)),
        onSetUserData: (userData) => dispatch(actionCreators.setUserData(userData)),
        onClearUserData: () => dispatch(actionCreators.clearUserData())
    }
};

export default connect(null, mapDispatchToProps)(AppWithAuth);
